export enum BLOCK_TYPE_MODES {
  /**
   * edit template
   */
  edit = "edit",
  /**
   * fill in note/form
   */
  fill = "fill",
  /**
   * print or preview
   */
  print = "print",
  download = "download",
}

export type TBlockType = keyof typeof BLOCK_TYPE_MODES;
